/**
 * Run `callback` once the browser is idle — after the current frame has painted — so
 * off-screen work (option lists, reference data, list pages behind an item view) never
 * competes with first paint. `timeoutMs` bounds the wait on a busy main thread. Falls back
 * to a zero-delay timeout where requestIdleCallback is missing (Safari, jsdom).
 *
 * Returns a cancel function, so it can be returned straight from a useEffect.
 */
export const runWhenIdle = (callback: () => void, { timeoutMs = 2000 }: { timeoutMs?: number } = {}): (() => void) => {
    if (typeof window.requestIdleCallback === "function") {
        const handle = window.requestIdleCallback(() => callback(), { timeout: timeoutMs })
        return () => window.cancelIdleCallback(handle)
    }
    const handle = window.setTimeout(callback, 0)
    return () => window.clearTimeout(handle)
}
